import { render } from "./CompanySecuritySetup.vue?vue&type=template&id=ec57ed0a&ts=true"
import script from "./CompanySecuritySetup.ts?vue&type=script&lang=ts&external"
export * from "./CompanySecuritySetup.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__